export default {
      id: "unit_dashboard__online-usage",
      viewBox: "0 0 28 28",
      url: __webpack_public_path__ + "img/icons.svg#unit_dashboard__online",
      toString: function () {
        return this.url;
      }
    }